<template src="@/components/Ork/OrkRootCategoryModal.html" />
<style lang="scss" scoped src="@/components/Ork/OrkRootCategoryModal.scss" />

<script>
import { configuration } from '@/config/InstanceConfiguration';
import {
  SfBar,
  SfButton,
  SfImage,
  SfModal,
  SfSelect,
  SfHeading
} from '@storefront-ui/vue';
import OrkLoader from '@/components/Ork/OrkLoader.vue';
import { shift, removeTrailingSlash } from '@/utils/Paths';

export default {
  name: 'OrkRootCategoryModal',
  components: {
    SfHeading,
    SfBar,
    SfSelect,
    SfImage,
    SfButton,
    SfModal,
    OrkLoader
  },
  data() {
    return {
      selectedRootCategoryPath: null,
      focusedRootCategoryLabel: null,
      loadingNewRootCategory: false
    }
  },
  computed: {
    returnToHomeAfterCatalogChange() { return configuration.navigation.catalogChange.returnToHome; },
    showRootCategoriesAsSelector() { return configuration.header.rootCategory.modal.showAsSelector },
    showRootCategoriesAsList() { return configuration.header.rootCategory.modal.showAsList },
    showFocusedRootCategoryLabel() { return configuration.header.rootCategory.modal.showFocused },
    isRootCategoryModalOpen() { return this.$store.getters.isRootCategoryModalOpen; },
    rootCategories() { return this.$store.getters.getRootCategories; },
    currentRootCategory() { return this.$store.getters.getRootCategory; },
    closeModalOnCatalogSelection() { return configuration.header.rootCategory.modal.closeOnNewSelection; }
  },
  watch: {
    currentRootCategory: {
      handler(newVal) {
        this.selectRootCategoryByPath(newVal?.path);
        this.setFocusedRootCategoryLabel(newVal?.label);
      },
      immediate: true
    }
  },
  methods: {
    selectRootCategoryByPath(rootCategoryPath) {
      this.selectedRootCategoryPath = rootCategoryPath;
      if (this.closeModalOnCatalogSelection) {
        this.closeRootCategoryModal()
      }
    },
    setFocusedRootCategoryLabel(categoryLabel) {
      this.focusedRootCategoryLabel = categoryLabel;
    },
    unsetFocusedRootCategory() {
      this.focusedRootCategoryLabel = this.currentRootCategory?.label || null;
    },
    closeRootCategoryModal() {
      if (this.isRootCategoryModalOpen && this.selectedRootCategoryPath) {
        this.loadingNewRootCategory = true
        return this.$store.dispatch('closeRootCategoryModal', this.selectedRootCategoryPath )
          .then(() => {
            if (this.returnToHomeAfterCatalogChange) {
              this.$router.push({
                name: "Home",
                params: {
                  locale: this.$route.params.locale,
                  catalog: removeTrailingSlash(this.currentRootCategory.path)
                }
              }).catch(() => {/* ignore */})
            }
            else {
              // Push current route without catalog info, router will complete them
              this.$router.push(shift(this.$route.fullPath, 2)).catch(() => {/* ignore */})
            }
          })
          .finally(() => this.loadingNewRootCategory = false)
      }
    }
  }
};
</script>